import React from 'react';
import styled from 'styled-components';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

export const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>arrangemessage</FooterLogo>
        <FooterLinks>
          <FooterLink href="/">Home</FooterLink>
          {/* <FooterLink href="#">Services</FooterLink> */}
          {/* <FooterLink href="ai-demo">AI Demo</FooterLink> */}
          <FooterLink href="/contact-us">Contact Us</FooterLink>
        </FooterLinks>
        <SocialIcons>
          {/* <SocialLink href="#"><FaFacebookF /></SocialLink> */}
          {/* <SocialLink href="#"><FaTwitter /></SocialLink> */}
          {/* <SocialLink href="#"><FaLinkedinIn /></SocialLink> */}
          <SocialLink href="https://www.instagram.com/arrangemessage/" target='_blank'><FaInstagram /></SocialLink>
        </SocialIcons>
      </FooterContent>
      <FooterBottom>
        &copy; {new Date().getFullYear()} arrangemessage. All rights reserved.
      </FooterBottom>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: #034C53;
  color: #EEF1DA;
  padding: 40px 20px;
  text-align: center;
`;

const FooterContent = styled.div`
  display: flex;
  background-color: #034C53;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const FooterLogo = styled.h1`
  font-size: 28px;
  font-family: raritas, sans-serif;
  font-weight: 200;
  
  font-family: raritas, sans-serif;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  background-color: #034C53;
`;

const FooterLink = styled.a`
  color: #EEF1DA;
  text-decoration: none;
  font-size: 18px;
  transition: 0.3s ease;

  &:hover {
    color: #66BFBF;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  background-color: #034C53;
`;

const SocialLink = styled.a`
  color: #EEF1DA;
  font-size: 22px;
  transition: 0.3s ease;
  

  &:hover {
    color: #66BFBF;
  }
`;

const FooterBottom = styled.div`
  margin-top: 20px;
  background-color: #034C53;
  font-size: 14px;
  opacity: 0.7;
`;

